import React from 'react';
import { ZoomIn, ZoomOut } from 'lucide-react';
import { motion } from 'framer-motion';
interface CanvasControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
}
export function CanvasControls({
  zoom,
  onZoomIn,
  onZoomOut
}: CanvasControlsProps) {
  return <div className="absolute bottom-6 right-6 bg-[#2D2D2D] border border-[#4A4A4A] rounded-lg p-2 flex flex-col gap-2 z-50 shadow-2xl" data-id="element-356">
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={onZoomIn} className="w-10 h-10 flex items-center justify-center text-[#B0B0B0] hover:text-white hover:bg-[#3A3A3A] rounded transition-colors cursor-pointer" title="Zoom In" data-id="element-357">
        <ZoomIn size={18} data-id="element-358" />
      </motion.button>

      <div className="px-2 py-1 text-center" data-id="element-359">
        <div className="text-[#B0B0B0] text-xs font-semibold" data-id="element-360">
          {Math.round(zoom * 100)}%
        </div>
      </div>

      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={onZoomOut} className="w-10 h-10 flex items-center justify-center text-[#B0B0B0] hover:text-white hover:bg-[#3A3A3A] rounded transition-colors cursor-pointer" title="Zoom Out" data-id="element-361">
        <ZoomOut size={18} data-id="element-362" />
      </motion.button>
    </div>;
}